import React from "react";
import ResetPinLayer from "../components/ResetPinLayer";

const ResetPinPage = () => {
    return (
        <>
            <ResetPinLayer />
        </>
    );
};

export default ResetPinPage;
